import { Reducer } from 'redux';

import { IDefaultShopConfig } from '../shopConfig/types';
import { DefaultShopTypes, IDefaultShopState } from './types';

const DEFAULT_ADDRESS: IDefaultShopConfig = {
  id: 0,
  name: '',
  cnpj: '',
  is_open: false,
  schedule: '',
  whatsapp: '',
  use_stock: false,
  use_stock_kg: false,
  address: {
    id: null,
    city: '',
    state: '',
    number: '',
    street: '',
    zipcode: '',
    neighborhood: '',
    country: null,
    client_id: null,
    reference: null,
    complement: null,
  },
  is_active: false,
  show_full_range: false,
  interval: 0,
  trade_name: null,
  company_name: null,
  pharmacist_responsible: null,
  pharmacist_crf: null,
  anvisa_registration: null,
  afe_authorization: null,
};

const DEFAULT_STATE: IDefaultShopState = {
  address: DEFAULT_ADDRESS,
  error: false,
  loading: false,
};

const reducer: Reducer<IDefaultShopState> = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case DefaultShopTypes.LOAD_REQUEST:
      return { ...state, loading: true };
    case DefaultShopTypes.LOAD_SUCCESS:
      return { ...state, loading: false, error: false, address: action.payload };
    case DefaultShopTypes.LOAD_FAILURE:
      return { ...state, loading: false, error: true, address: DEFAULT_ADDRESS };
    default:
      return state;
  }
};

export default reducer;
